import React from "react";
import { Route, Routes } from "react-router-dom";
import RateSlider from "../components/common/RateSlider";
import FinalPayment from "../components/layouts/checkout/FinalPayment";
import EditProfile from "../components/layouts/userPanel/EditProfile";
import EditResidences from "../layouts/EditResidences";
import MyCounter from "../components/layouts/userPanel/MyCounter";
import UserComments from "../components/layouts/userPanel/UserComments";
import UserMyTrips from "../components/layouts/userPanel/UserMyTrips";
import UserNotification from "../components/layouts/userPanel/UserNotification";
import UserReserve from "../components/layouts/userPanel/UserReserve";
import UserStatics from "../components/layouts/userPanel/UserStatics";
import Wallete from "../components/layouts/userPanel/Wallete";
import WishList from "../components/layouts/userPanel/WishList";
import { CreatePlaceProvider } from "../context/CreatePlaceContext";
import { UserContextProvider } from "../context/UserContext";
import Blog from "../layouts/Blog";
import BlogDetail from "../layouts/BlogDetail";
import Categories from "../layouts/Categories";
import Checkout from "../layouts/Checkout";
import Create from "../layouts/Create";
import Home from "../layouts/Home";
import HomeLayout from "../layouts/HomeLayout";
import Hosting from "../layouts/Hosting";
import PlaceDetail from "../layouts/PlaceDetail";
import Register from "../layouts/Register";
import UserPanelLayout from "../layouts/UserPanelLayout";
import NotFoundPage from "../layouts/NotFoundPage";
import AdminLayout from "../layouts/AdminLayout";
import AdminResidences from "../components/layouts/admin/AdminResidences/AdminResidences";
import AdminCategories from "../components/layouts/admin/AdminCategories/AdminCategories";
import AdminNotification from "../components/layouts/admin/AdminNotification/AdminNotification";
import AdminFastSearch from "../components/layouts/admin/AdminFestSearch/AdminFastSearch";
import AdminUsers from "../components/layouts/admin/AdminUsers/AdminUsers";
import AddUsers from "../components/layouts/admin/AdminUsers/AddUsers";
import AdminJudje from "../components/layouts/admin/AdminJudje/AdminJudje";
import AdminBlog from "../components/layouts/admin/AdminBlog/AdminBlog";
import AdminUserCommentsrow from "../components/layouts/admin/AdminUsersComments.js/AdminUserCommentsrow";
import AdminUsersComments from "../components/layouts/admin/AdminUsersComments.js/AdminUsersComments";
import AdminAddFaq from "../components/layouts/admin/AdminAddFaq/AdminAddFaq";
import AddFaqForm from "../components/layouts/admin/AdminAddFaq/AddFaqForm";
import FaqList from "../components/layouts/admin/AdminAddFaq/FaqList";
import AdminUserFeedbacks from "../components/layouts/admin/AdminUserFeedbacks/AdminUserFeedbacks";
import AdminWage from "../components/layouts/admin/AdminWage/AdminWage";
import AdminJudgeDetail from "../components/layouts/admin/AdminJudje/AdminJudgeDetail";
import AdminAds from "../components/layouts/admin/AdminAds/AdminAds";
import AdmincreateAds from "../components/layouts/admin/AdminAds/AdmincreateAds";
import AdminResidenceDetail from "../layouts/AdminResidenceDetail";
import FAQ from "../layouts/FAQ";
const Authenticated = () => {

  return (
    <div>
      
      <Routes>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/place/:code/:slug" element={<PlaceDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id/:slug"  element={<BlogDetail />} />
          <Route path="/create" element={<Create />} />
          <Route path="/create/:id/:step/:substep" element={<Create />} />
          <Route path="/checkout/:slug/:code/:id" element={<Checkout />} />
          <Route path="/checkout/payments/:slug/:code/:id" element={<FinalPayment />} />
          <Route path="/hosting" element={<Hosting />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path='*' element={<NotFoundPage />} />
        </Route>
        <Route element={<UserPanelLayout />}>
          <Route path="/user/" element={<MyCounter />} />
          <Route path="/user/wallet" element={<Wallete />} />
          <Route path="/user/wishlist" element={<WishList />} />
          <Route path="/user/editprofile" element={<EditProfile />} />
          <Route path="/user/notification" element={<UserNotification />} />
          <Route path="/user/comments" element={<UserComments />} />
          <Route path="/user/reserve" element={<UserReserve />} />
          <Route path="/user/statics" element={<UserStatics />} />
          <Route path="/user/mytrips" element={<UserMyTrips />} />
        </Route>
      
        <Route path="/place/edit/:code/:slug/:id" element={<EditResidences />} />
        <Route path="/finnotech/callback" element={<h1 >test finontech</h1>} />
        <Route element={<AdminLayout />}>
          <Route path="/admin/residences" element={<AdminResidences />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/notification" element={<AdminNotification />} />
          <Route path="/admin/fast-search" element={<AdminFastSearch />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/add-user" element={<AddUsers />} />
         <Route path="/admin/judje" element={<AdminJudje />} />
         <Route path="/admin/judje/:id" element={<AdminJudgeDetail />} />
         <Route path="/admin/users-comments" element={<AdminUsersComments />} />
          <Route path="/admin/feedback" element={<AdminUserFeedbacks />} />
          <Route path="/admin/blogs" element={<AdminBlog />} /> 
          <Route path="/admin/Add-Faq" element={<AdminAddFaq />} /> 
          <Route path="/admin/Faq-list" element={<FaqList />} /> 
          <Route path="/admin/Faq-form" element={<AddFaqForm />} /> 
          <Route path="/admin/wage" element={<AdminWage />} /> 
          <Route path="/admin/ads-panel" element={<AdminAds />} /> 
          <Route path="/admin/create-ads" element={<AdmincreateAds />} /> 
 
        </Route>
        <Route path="/admin/place/:code/:slug/:id" element={<AdminResidenceDetail />} /> 



      </Routes>
    </div>
  );
};

export default Authenticated;
